import { render, staticRenderFns } from "./DirectivesWrapper.vue?vue&type=template&id=86a53a3a"
import script from "./DirectivesWrapper.vue?vue&type=script&lang=js"
export * from "./DirectivesWrapper.vue?vue&type=script&lang=js"
import style0 from "./DirectivesWrapper.vue?vue&type=style&index=0&id=86a53a3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports